import {useInjection} from 'dna-react-ioc'
import {AuthStoreInterface, AuthStoreSymbol} from '@/stores'

export * from './AuthStore'
export * from './AuthStoreInterface'

export const useAuthStore = () => useInjection<AuthStoreInterface>(AuthStoreSymbol)
